import { BASE_API_ENDPOINT } from '@atom/utilities/endpoints';

import classes from './login.module.css';

type SsoLoginButtonProps = {
  text: string;
  logo: string;
  connection: string;
  prompt?: string;
};

const buildLoginUrl = (connection: string, prompt?: string) => {
  const params = new URLSearchParams({ connection });

  if (prompt) {
    params.set('prompt', prompt);
  }

  return `${BASE_API_ENDPOINT}/auth/social?${params}`;
};

const SsoLoginButton = ({
  text,
  logo,
  connection,
  prompt,
}: SsoLoginButtonProps) => (
  <a href={buildLoginUrl(connection, prompt)} className={classes.ssoButtonLink}>
    <div className={classes.ssoButton}>
      <div className={classes.ssoButtonLogo}>
        <img className={classes.ssoButtonLogoImage} src={logo} alt="" />
      </div>
      <span className={classes.ssoButtonText}>{text}</span>
    </div>
  </a>
);

export default SsoLoginButton;
